import React, { Component } from "react";
import { connect } from "react-redux";
import AgentPMA from "./AgentPMA";
import { pmaActions } from "_store/_actions";
import { GetStateStorage, IsValidNavbarData } from "common/storage";
import { WebsiteLayout } from "layouts";
import { CircularProgress, Typography } from "@mui/material";
import PMAIssueReportsDialog from "./PMAIssueReportsDialog";
import { isEmpty } from "lodash";
import { withRouter } from "common/utils/router.util";

class PMAMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navbarData: {},
      resetLocalState: false,
      openDrawer: false,
      isFullMode: true,
      enableMailProApprovalProcess: false, //no need to touch this as it will have no effect. use component Did Mount. It iwll controlled by backend now
      openPMAIssuesDialog: false,
      enablePMAInformationDialog: false,
      // enablePMAInformationDialog: true,// true means system will display the PMA info dialog. When we push Year End PMA then make it false
      openPMAInformationDialog: false,
    };
    /**bind methods */
    this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
    this.handlePMAIssuesDialog = this.handlePMAIssuesDialog.bind(this);
  }

  // removed unsafe lifecycle; use componentDidUpdate if needed

  componentDidMount() {
    const stateData = GetStateStorage();
    const agentData = stateData.userData;
    //check if state data not founf

    const { switchArea, history } = this.props;

    let paramAreaID = this.props.match?.params?.areaID;

    let navbarInfo;

    let areaIDList = agentData.navbarInfo.map((area) => area.mlsAreaID);

    let idMatches = areaIDList.indexOf(paramAreaID) >= 0; //if session switch, if the agent does not have the navbar area id that matches the url, then we need to take the first navbar area for the agent because that means that they are being switched from one agent to another on admin side
    // console.log("idMatches", idMatches);

    if (agentData && Array.isArray(agentData.navbarInfo)) {
      if (!idMatches) {
        console.log("id doesnt match", agentData);
        navbarInfo = agentData.navbarInfo[0];
        history.push(`/pma/${agentData.navbarInfo[0].mlsAreaID}`);
      } else {
        navbarInfo = agentData.navbarInfo.filter(
          (area) => area.mlsAreaID === paramAreaID
        )[0];
      }
    } else {
      navbarInfo = {};
    }

    const isValid = IsValidNavbarData();

    !this.props.mlsAreas.length &&
      this.props.getNavbarInfo(stateData.userData.listgenUserID, navbarInfo);
    switchArea(navbarInfo);
    /**get next pma print date */
    this.props.getNextPMAPrintDate();

    const { mlsAreaID } = navbarInfo;

    this.props.getAgentQR(agentData.agentLicenseNumber, mlsAreaID);
    let showApproval = []; // ["101003", "101006", "100474"];

    if (showApproval.includes(agentData.listgenUserID)) {
      this.setState({
        enableMailProApprovalProcess: true, //it's also linked with mailpro approval button is also enable
      });
    } else {
      this.setState({
        enableMailProApprovalProcess: agentData.enableApprovalButton || false, //check the agent data for this process
      });
    }
    if (isValid) {
      this.setState({
        navbarData: navbarInfo,
      });
      switchArea(navbarInfo);
    } else {
    }
    /**now scroll to top also */
    window.scrollTo(0, 0);
    //show the pma information dialog
    if (this.state.enablePMAInformationDialog) {
      this.setState({
        openPMAInformationDialog: true,
      });
    }
  }

  handleDrawerOpen = () => {
    this.setState({
      openDrawer: true,
    });
  };

  handleDrawerClose = () => {
    this.setState({
      openDrawer: false,
    });
  };

  handlePMAIssuesDialog = (openDialog = false) => {
    this.setState({
      openPMAIssuesDialog: openDialog,
    });
  };

  render() {
    const {
      mlsAreas,
      currentArea,

      propertyData,
      qrCodeMailerProID,
    } = this.props;
    const stateData = GetStateStorage();
    const agentData = stateData.userData;
    const { mlsCityName } = currentArea;

    const { pmaScheduleID } = agentData;
    let isUnavailable = false;

    return (
      <WebsiteLayout
        sidebarMode={true}
        openSidebarModeSidebar={this.state.openDrawer}
        sidebarModeHandleClose={this.handleDrawerClose}
        hideFooter={true}
      >
        {this.state.openPMAIssuesDialog ? (
          <PMAIssueReportsDialog
            handlePMAIssuesDialog={this.handlePMAIssuesDialog}
            currentArea={this.props.currentArea}
          />
        ) : (
          ""
        )}

        {mlsAreas &&
        mlsAreas.length >= 1 &&
        !isEmpty(currentArea) ? (
          <AgentPMA
            agentData={agentData}
            mlsAreas={mlsAreas}
            navbarData={currentArea}
            handleDrawerOpen={this.handleDrawerOpen}
            isFullProMode={this.state.isFullMode}
            enableMailProApprovalProcess={
              this.state.enableMailProApprovalProcess
            }
            handlePMAIssuesDialog={this.handlePMAIssuesDialog}
            propertyData={propertyData}
            qrCodeMailerProID={qrCodeMailerProID}
            //version={version}
            //switchVersion={this.switchVersion}
            isUnavailable={isUnavailable}
          />
        ) : (
          <div
            style={{
              height: "80vh",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "row",
              background: "inherit",
            }}
          >
            <div>
              <CircularProgress />
            </div>
            {/* style={{ marginTop: '2vh', marginLeft: '2vh' }} */}
            <div>
              <Typography variant="subtitle2">
                &nbsp;&nbsp;Loading...
              </Typography>
            </div>
          </div>
        )}
      </WebsiteLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentArea: state.pma.currentArea,
    mlsAreas: state.pma.mlsAreas,
    localStorageData: state.localStorageData,
    version: state.pma.version,
    currentStep: state.pma.currentStep,
    propertyData: state.pma.propertyData,
    isLoading: state.pma.isLoading,
    nextPMAPrintDate: state.pma.nextPMAPrintDate,
    qrCodeMailerProID: state.pma.qrCodeMailerProID,
  };
};
function mapDispatchToProps(dispatch) {
  return {
    getNavbarInfo: (listgenUserID) =>
      dispatch(pmaActions.getNavbarInfo(listgenUserID)),
    switchArea: (area) => dispatch(pmaActions.switchArea(area)),
    switchStep: (step) => dispatch(pmaActions.switchStep(step)),
    getNextPMAPrintDate: () => dispatch(pmaActions.getNextPMAPrintDate()),
    updateLocalStorageDataForRedux: (localStorageData) =>
      dispatch(pmaActions.updateLocalStorageDataForRedux(localStorageData)),
    switchVersion: (version) => {
      dispatch(pmaActions.switchVersion(version));
    },
    explicitEnableNewMailProInitFn: (data) =>
      dispatch(pmaActions.explicitEnableNewMailProInitFn(data)),
    changeLoading: (status) => {
      dispatch(pmaActions.changeLoading(status));
    },

    getAgentQR: (agentLicenseNumber, areaId) => {
      dispatch(pmaActions.getAgentQR(agentLicenseNumber, areaId));
    },
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PMAMain));
